module.exports = __webpack_public_path__ + "img/logo.89fbba77.png";